import React from 'react';
import { useIntl } from 'react-intl-next';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { ShowMoreHorizontalIcon, ToolbarDropdownMenu, ToolbarTooltip } from '@atlaskit/editor-toolbar';
export var OverflowMenu = function OverflowMenu(_ref) {
  var children = _ref.children;
  var intl = useIntl();
  var tooltipContent = intl.formatMessage(toolbarMessages.selectionToolbarOverflowMenuTooltip);
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: tooltipContent,
    position: "top"
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    label: tooltipContent,
    iconBefore: /*#__PURE__*/React.createElement(ShowMoreHorizontalIcon, {
      label: ""
    })
  }, children));
};